import CustomBuildingEstimate from '@/models/CustomBuildingEstimate'
import DataAndObjectFunctions from '@/util/DataAndObjectFunctions'

export default {

  setJurisdictionBuildingEstimates(state, { jurisdiction_id, building_estimates }) {
    state.jurisdiction_building_estimates = state.jurisdiction_building_estimates.removeAllInArray({ jurisdiction_id })
    state.jurisdiction_building_estimates = [ ...state.jurisdiction_building_estimates, ...building_estimates]
  },

  deleteCustomBuildingEstimateOfPolicy(state, policy_id) {
    state.custom_building_estimates = state.custom_building_estimates.filter((cbe) => cbe.policy_id !== policy_id)
  },

  setCustomBuildingEstimates(state, {custom_building_estimates, policy_id_selected = null }) {
    const stateCustomBuildingEstimates = [...state.custom_building_estimates]
    const payloadCustomBuildingEstimatesCopy = custom_building_estimates.map(pcbe => new CustomBuildingEstimate(pcbe))

    payloadCustomBuildingEstimatesCopy.forEach(cbe => {
      const filterPayload = DataAndObjectFunctions.filterObjectKeys(CustomBuildingEstimate.filtrableKeys, cbe)
      filterPayload.policy_id = policy_id_selected

      const buildingEstimateExists = stateCustomBuildingEstimates.findInArray(filterPayload)
      if (buildingEstimateExists) {
        buildingEstimateExists.id = cbe.id
        buildingEstimateExists.units = cbe.units
        buildingEstimateExists.user_id = cbe.user_id
      } else {
        stateCustomBuildingEstimates.push(cbe)
      }
    })

    state.custom_building_estimates = [ ...stateCustomBuildingEstimates ]
  },
  
  clearAllBuildingEstimates(state) {
    state.jurisdiction_building_estimates = []
    state.custom_building_estimates = []
  },
  
  clearCustomBuildingEstimates(state, cbe_to_clear = null) {
    if (cbe_to_clear?.length) {
      state.custom_building_estimates = [...state.custom_building_estimates].filter(cbe => {
        return !cbe_to_clear.findInArray({
          building_height_id: cbe.building_height_id,
          construction_implementation_type_id: cbe.construction_implementation_type_id,
          type_prototype_id: cbe.type_prototype_id,
          climate_zone_prefix: cbe.climate_zone_prefix,
          year: cbe.year,
          jurisdiction_id: cbe.jurisdiction_id,
          policy_id: cbe.policy_id
        })
      })
    } else {
      state.custom_building_estimates = []
    }
  },

  buildingEstimatesInit(state) {
    state.is_updating = true
  },
  
  buildingEstimatesFinish(state) {
    state.is_updating = false
  },
  
  buildingEstimatesFail(state) {
    state.is_updating = false
  },

  buildingEstimateStoreInit(state) {
    state.is_updating = true
  },
  
  buildingEstimateStoreFinish(state) {
    state.is_updating = false
  },
  
  buildingEstimateStoreFail(state) {
    state.is_updating = false
  },

  buildingEstimatesStoreInit(state) {
    state.is_updating = true
  },
  
  buildingEstimatesStoreFinish(state) {
    state.is_updating = false
  },
  
  buildingEstimatesStoreFail(state) {
    state.is_updating = false
  },

}
